import { getConfig } from '../config';
import { envsWithLoggingEnable } from '../constants';

const env = getConfig('ENV');

const exception = ({ message = 'Something went wrong', type = 'notification',  status, label = 'Error', info } = {}) => {
  const returnErrorObject = {
    message,
    type,
  };

  if (status) returnErrorObject['status'] = status;
  if (info) returnErrorObject['info'] = info;

  if (envsWithLoggingEnable.includes(env)) {
    console.log(`${label} `, returnErrorObject);
  }

  return returnErrorObject;
};

export default exception;
